import { FC } from "react"
import classNames from "classnames"
import WearableCardContent from "./WearableCardContent"
import { WearableCardProps } from "."

interface WearableCardLargeProps extends WearableCardProps {
   isExpanded?: boolean
}

const WearableCardLarge: FC<WearableCardLargeProps> = ({
   onClick,
   isClickable,
   isExpanded,
   ...props
}) => {
   return (
      <div
         className={classNames("wearable-card", {
            "wearable-card--expanded": isExpanded,
            "wearable-card--clickable": isClickable,
         })}
         onClick={onClick}
      >
         <WearableCardContent {...props} />
      </div>
   )
}

export default WearableCardLarge
